import { ValidationView } from '../../../fragments/admin/price-extractions/ValidationView'

const ValidateExtraction = () => {
    return (
        <main>
            <ValidationView />
        </main>
    )
}

export default ValidateExtraction
